import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
//Screens
import Home from "./components/home/Home";
import Sync from "./components/sync/Sync";
import Login from "./components/login/Login";
import Loader from "./components/common/Loader";
import React from "react";
import ProtectedRoute from "./components/common/ProtectedRoute";
// import Tabbar from './components/common/Tabbar/Tabbar';
import Track from "./components/track/Track";
import Notes from "./components/notes/Notes";
import ListNotes from "./components/list-notes/ListNotes";
import Schedule from "./components/schedule/Schedule";
import Language from "./components/language/Language";
import { useTranslation } from "react-i18next";
import Tabbar from "./components/common/Tabbar/Tabbar";
import WashInventory from "./components/washInventory/WashInventory";
import Header from "./components/common/Header/Header";
import { Container, Row, Stack } from "react-bootstrap";
import { getAllAccountsSummary, listFleet } from "./service/accountService";
import { getWashTypes } from "./service/washTypeService";
import {
  getAllWashInventory,
  getWashInventoryWithinDays,
  getAllWashNotes,
  getInstructionAcknowledgements,
  addAcknowledgement,
} from "./service/wash-inventory-service";
import moment from "moment";
import {
  isEmpty,
  removeLocalStorage,
  setLocalStorage,
} from "./components/common/helper";
import Forgotpassword from "./components/forgotpassword/ForgotPassword";
import ForgotPassword from "./components/forgotpassword/ForgotPassword";
import ResetPassword from "./components/login/ResetPassword";
import { ToastContainer, toast } from "react-toastify";
import {
  getLoaderToastSettings,
  getLoaderToastMessage,
  getToastSettings,
} from "./components/common/ToastManager";
import {
  addWashInventory,
  addNote,
  updateNote,
} from "./service/wash-inventory-service";
import { addSignature } from "./service/signatureService";
import Notify from "./components/notify/customerNotificationService";
import { useSelectedOrgId } from "./hooks/useSelectedOrgId";
import { useLeadUser } from "./hooks/useLeadUser";
import ChooseOrganization from "./components/organization/ChooseOrganization";
export const UserContext = React.createContext({});

function App() {
  const { i18n } = useTranslation();
  const [selectedOrgId] = useSelectedOrgId();
  const [leadUser] = useLeadUser();
  const [loading, setLoading] = useState(false);
  const [user, setLeadUser] = useState("");
  const [tabName, setTabName] = useState("home");
  const [leadLanguage, setLeadLanguage] = useState([]);
  const [accountSummary, setAccountSummary] = useState([]);
  const [instructionAcknowledgements, setInstructionAcknowledgements] =
    useState([]);
  const [washTypes, setWashTypes] = useState([]);
  const [accountWashTypes, setAccountWashTypes] = useState([]);
  const [vehicleNumberList, setVehicleNumberList] = useState([]);
  const [washInventory, setWashInventory] = useState({});
  const [washInventoryList, setWashInventoryList] = useState([]);
  const [washNotesList, setWashNotesList] = useState([]);
  const [washedFleetList, setWashedFleetList] = useState([]);
  const [syncedWashInventoryList, setSyncesdWashInventoryList] = useState([]);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [signatureAdded, setSignatureAdded] = useState(false);
  const [isNoteUpdateSuccess, setIsNoteUpdateSuccess] = useState(false);

  const toastLoader = (toastMessage) =>
    toast.loading(toastMessage, getLoaderToastSettings());
  const toastLoaderUpdate = (id, toastMessage, type) =>
    toast.update(id, getLoaderToastMessage(toastMessage, type));

  let navigate = useNavigate();
  useEffect(() => {
    var localUser = JSON.parse(localStorage.getItem("leadUser"));
    var localLanguage = localStorage.getItem("leadLanguage");
    setLeadLanguage(localLanguage ? localLanguage : "en");
    i18n.changeLanguage(localLanguage ? localLanguage : "en");
    if (localUser) {
      if (localUser.isPasswordReset) {
        setIsPasswordReset(true);
        navigate("/reset/password");
      }
      setLeadUser(localUser);
    }
  }, []);

  function setUserLead(result) {
    if (result) {
      setLeadUser(result);
      if (result.roleCode === "SADM") {
        navigate("/choose");
      } else if (result.isPasswordReset) {
        setIsPasswordReset(true);
        navigate("/reset/password");
      } else {
        navigate("/");
      }
    } else {
      setLeadUser("");
    }
  }

  function setLocalLanguage(language) {
    localStorage.setItem("leadLanguage", language);
    window.location.reload();
  }

  function onResetPassword() {
    setIsPasswordReset(false);
    setLeadUser((prevState) => ({
      ...prevState,
      isPasswordReset: 0,
    }));
    window.location.reload();
    navigate("/");
  }

  useEffect(() => {
    if (user) {
      localStorage.setItem("leadUser", JSON.stringify(user));
    }

    if (user.token && !user.isPasswordReset && selectedOrgId) {
      fetchAccountListSummary();
      fetchAllWashTypes();
      fetchAccountWashTypes();
      fetchVehicleNumberList();
      fetchAllWashInventories();
      fetchAllWashNotes();
      fetchWashInventoryForLast30Days();
      fetchInstructionAcknowledgements();
    }
  }, [user, selectedOrgId]);

  useEffect(() => {
    fetchAccountWashTypes();
  }, [accountSummary]);

  useEffect(() => {
    if (!isEmpty(washInventory)) {
      let filteredWashList = getFilteredWashInventoryListBasedOnVehicleNo();
      setWashInventoryList([...washInventoryList, ...filteredWashList]);
    }
  }, [washInventory]);

  useEffect(() => {
    if (!isEmpty(washInventoryList)) {
      syncWashInventories();
    }
  }, [washInventoryList]);

  function setLocalWashInventory(data) {
    localStorage.setItem("tempWashInventory", JSON.stringify(data));
  }

  function getLocalWashInventory() {
    var localWashInventoryList = localStorage.getItem("tempWashInventory");
    return localWashInventoryList ? JSON.parse(localWashInventoryList) : [];
  }

  function getFilteredWashInventoryListBasedOnVehicleNo() {
    let newList = [];
    for (let i = 0; i < washInventory.vehicleNumbers.length; i++) {
      let newWashInventory = {
        accountId: parseInt(washInventory.accountId),
        accountName: washInventory.accountName,
        washTypeId: washInventory.washTypeId,
        washTypeName: washInventory.washTypeName,
        leadId: washInventory.leadId,
        teamId: washInventory.teamId,
        vehicleNumber: washInventory.vehicleNumbers[i],
        uuid: washInventory.uuid[i],
        invoiceFrequency: washInventory.invoiceFrequency,
        comments: washInventory.comments,
        startTime: washInventory.startTime,
        endTime: washInventory.endTime,
      };
      newList.push(newWashInventory);
    }
    return newList;
  }

  const fetchAllWashTypes = async () => {
    let response = await getWashTypes(selectedOrgId);
    if (response.status === 200) {
      setWashTypes(response.data ? response.data.Washtypes : []);
    }
  };

  const fetchAccountWashTypes = async () => {
    const washTypes = accountSummary.reduce((acc, item) => {
      acc[item.accountId] = item.washTypeIds;
      return acc;
    }, {});
    setAccountWashTypes(washTypes);
  };

  const fetchAccountListSummary = async () => {
    let response = await getAllAccountsSummary(selectedOrgId);
    if (response.status === 200) {
      setAccountSummary(response.data ? response.data.accountSummary : []);
    }
  };

  const fetchInstructionAcknowledgements = async () => {
    let response = await getInstructionAcknowledgements(
      selectedOrgId,
      moment().utc().format("YYYY-MM-DD"),
    );
    if (response.status === 200) {
      setInstructionAcknowledgements(
        response.data ? response.data.instructionAcknowledgements : [],
      );
    }
  };

  const fetchVehicleNumberList = async () => {
    let response = await listFleet(selectedOrgId);
    if (response.status === 200) {
      setVehicleNumberList(response.data ? response.data.response : []);
    }
  };

  const fetchAllWashInventories = async () => {
    console.log("fetchAllWashInventories");
    let today = new Date();
    let response = await getAllWashInventory(0, 0, 0, 0, selectedOrgId);
    if (response.status === 200) {
      setWashInventoryList(response.data.washInventory);
    }
    console.log(response.data.washInventory);
  };

  const fetchAllWashNotes = async () => {
    console.log("fetchAllWashNotes");
    let today = moment().utc().endOf("day").format();
    let thirtyDaysBack = moment()
      .utc()
      .subtract(30, "days")
      .startOf("day")
      .format();
    let response = await getAllWashNotes(
      selectedOrgId,
      0,
      0,
      0,
      thirtyDaysBack,
      today,
    );
    if (response.status === 200) {
      setWashNotesList(response.data.washNotes);
    }
    console.log(response.data.washNotes);
  };

  const fetchWashInventoryForLast30Days = async () => {
    let response = await getWashInventoryWithinDays(30, selectedOrgId);
    if (response.status === 200) {
      const latestWashRecords = Object.values(
        response.data.washInventory.reduce((acc, item) => {
          const key = `${item.accountId}-${item.washTypeId}-${item.vehicleNumber}-${item.locationNumber}`;

          if (
            !acc[key] ||
            new Date(acc[key].startTime) < new Date(item.startTime)
          ) {
            acc[key] = item;
          }

          return acc;
        }, {}),
      );
      setWashedFleetList(latestWashRecords);
    }
  };

  function syncWashInventories() {
    var localWashList = getLocalWashInventory();
    let syncedList = [];
    if (localWashList.length == 0) {
      syncedList.push(...washInventoryList);
    } else if (washInventoryList.length == 0) {
      syncedList.push(...localWashList);
    } else {
      washInventoryList.forEach((wash) => {
        let isWashSync = false;
        localWashList.forEach((localWash, index) => {
          if (
            wash.accountId == localWash.accountId &&
            wash.washTypeId == localWash.washTypeId &&
            wash.vehicleNumber == localWash.vehicleNumber
          ) {
            syncedList.push(wash);
            localWashList.splice(index, 1);
            isWashSync = true;
          }
        });
        if (!isWashSync) {
          syncedList.push(wash);
        }
      });
      syncedList = [...syncedList, ...localWashList];
    }
    setLocalWashInventory(syncedList);
    setSyncesdWashInventoryList(syncedList);
  }

  function setTab(tabName) {
    setTabName(tabName);
  }
  const createBulkWashInventory = async (data) => {
    const responses = [];
    const toastId = toastLoader("Please wait...");
    try {
      await Promise.all(
        data.map(async (washData) => {
          try {
            const response = await addWashInventory(washData, selectedOrgId);
            responses.push({ washType: washData.washTypeName, response });
          } catch (error) {
            console.log("error :", error);
            responses.push({ washType: washData.washTypeName, error });
          }
        }),
      );
      responses.forEach(({ washType, response, error }) => {
        if (error) {
          toastLoaderUpdate(
            toastId,
            `Wash inventory failed for ${washType}!`,
            "error",
          );
        } else {
          if (response.status === 201) {
            toastLoaderUpdate(
              toastId,
              "Wash inventory created successfully",
              "success",
            );
            fetchAllWashInventories();
          } else {
            if (response.data.error.errorCode == "allFleetsExist") {
              toastLoaderUpdate(
                toastId,
                "Fleet entry has already been entered.",
                "error",
              );
            } else {
              toastLoaderUpdate(toastId, "Wash inventory failed!", "error");
            }
          }
        }
      });
      fetchAllWashInventories();
    } catch (error) {
      console.log("error :", error);
      toastLoaderUpdate(
        toastId,
        "Stored locally. waiting for network to sync.",
        "error",
      );
      data.forEach((washData) => {
        setWashInventory(washData);
      });
    }
  };

  const createWashInventory = async (data) => {
    let toastId = toastLoader("Please wait...");
    try {
      let response = await addWashInventory(data, selectedOrgId);
      if (response.status === 201) {
        toastLoaderUpdate(
          toastId,
          "Wash inventory created successfully",
          "success",
        );
        fetchAllWashInventories();
      } else {
        if (response.data.error.errorCode == "allFleetsExist") {
          toastLoaderUpdate(
            toastId,
            "Fleet entry has already been entered.",
            "error",
          );
        } else {
          toastLoaderUpdate(toastId, "Wash inventory failed!", "error");
        }
      }
    } catch (error) {
      console.log("error :", error);
      toastLoaderUpdate(
        toastId,
        "Stored locally. waiting for network to sync.",
        "error",
      );
      setWashInventory(data);
    }
  };

  const createNote = async (data) => {
    let toastId = toastLoader("Please wait...");
    try {
      let response = await addNote(data, selectedOrgId);
      if (response.status === 201) {
        toastLoaderUpdate(toastId, "Note created successfully", "success");
        fetchAllWashInventories();
        fetchAllWashNotes();
      } else {
        toastLoaderUpdate(toastId, "Note creation failed!", "error");
      }
    } catch (error) {
      console.log("error :", error);
      toastLoaderUpdate(
        toastId,
        "Stored locally. waiting for network to sync.",
        "error",
      );
    }
  };

  const createAcknowledgement = async (data) => {
    let toastId = toastLoader("Please wait...");
    try {
      let response = await addAcknowledgement(data, selectedOrgId);
      if (response.status === 201) {
        toastLoaderUpdate(
          toastId,
          "Instruction acknowledged successfully",
          "success",
        );
        fetchInstructionAcknowledgements();
      } else {
        toastLoaderUpdate(toastId, "Instruction acknowledge failed!", "error");
      }
    } catch (error) {
      console.log("error :", error);
      toastLoaderUpdate(
        toastId,
        "Stored locally. waiting for network to sync.",
        "error",
      );
    }
  };

  const editNote = async (data) => {
    let toastId = toastLoader("Please wait...");
    try {
      let response = await updateNote(data, selectedOrgId);
      if (response.status === 200) {
        toastLoaderUpdate(toastId, "Note updated successfully", "success");
        fetchAllWashNotes();
        setIsNoteUpdateSuccess(true);
      } else {
        toastLoaderUpdate(toastId, "Note updation failed!", "error");
      }
    } catch (error) {
      console.log("error :", error);
      toastLoaderUpdate(
        toastId,
        "Stored locally. waiting for network to sync.",
        "error",
      );
    }
  };

  let toastId;
  function setToastMessage(message) {
    if (!toastId) {
      toastId = toastLoader("Please wait...");
    }
    toastLoaderUpdate(toastId, message, "warning");
    setTimeout(() => {
      clearToastMessage();
    }, 3000);
  }

  function clearToastMessage() {
    if (toastId) {
      toast.dismiss(toastId);
      toastId = null;
    }
  }

  const createSignature = async (data) => {
    let toastId = toastLoader("Please wait...");
    let response = await addSignature(data);
    if (response.status === 200) {
      toastLoaderUpdate(
        toastId,
        "Wash inventory approverd successfully!",
        "success",
      );
      fetchAllWashInventories();
      window.location.reload(true);
    } else {
      response.status
        ? toastLoaderUpdate(toastId, "Wash inventory approval failed!", "error")
        : toastLoaderUpdate(
            toastId,
            "Stored locally. waiting for network to sync.",
            "error",
          );
    }
  };

  return (
    <UserContext.Provider value={user ? user : ""}>
      <Loader loading={loading} />

      {/* <div className="App" style={{ pointerEvents: (loading) ? 'none' : 'auto' }}> */}
      <Container style={{ maxWidth: "inherit" }}>
        <Row>
          <Header />
        </Row>
        <Row style={{ minHeight: "100vh" }}>
          <Routes>
            <Route
              path="/login"
              element={
                user.token ? (
                  leadUser && leadUser.roleCode === "SADM" ? (
                    <Navigate to="/choose" />
                  ) : (
                    <Navigate to="/" />
                  )
                ) : (
                  <Login
                    setTab={setTab}
                    onLogin={setUserLead}
                    onSave={setLocalLanguage}
                    leadLanguage={leadLanguage}
                  />
                )
              }
            />
            <Route
              path="/choose"
              element={
                !user.token ? (
                  <Navigate to="/" />
                ) : (
                  <ProtectedRoute>
                    <ChooseOrganization />
                  </ProtectedRoute>
                )
              }
            />
            <Route
              path="/reset/password"
              element={
                !user.isPasswordReset ? (
                  <Navigate to="/" />
                ) : (
                  <ProtectedRoute>
                    <ResetPassword onReset={onResetPassword} />
                  </ProtectedRoute>
                )
              }
            />
            <Route
              path="/forgotpassword"
              element={user.token ? <Navigate to="/" /> : <ForgotPassword />}
            />
            <Route path="/" element={<Home setTab={setTab} />} />
            <Route
              path="/language"
              element={<Language onSave={setLocalLanguage} />}
            />
            <Route
              path="/schedule"
              element={
                <ProtectedRoute>
                  <Schedule setTab={setTab} accountSummary={accountSummary} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/track"
              element={
                <ProtectedRoute>
                  <Track
                    setTab={setTab}
                    washInventory={washInventory}
                    washInventoryList={syncedWashInventoryList}
                    accountSummary={accountSummary}
                    createSignature={createSignature}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notes"
              element={
                <ProtectedRoute>
                  <Notes
                    setTab={setTab}
                    accountSummary={accountSummary}
                    washTypes={washTypes}
                    washInventoryList={syncedWashInventoryList}
                    vehicleNumberList={vehicleNumberList}
                    setToastMessage={setToastMessage}
                    onSave={createNote}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/list-notes"
              element={
                <ProtectedRoute>
                  <ListNotes
                    setTab={setTab}
                    notesList={washNotesList}
                    onSave={editNote}
                    isUpdateSuccess={isNoteUpdateSuccess}
                    resetUpdateSuccess={setIsNoteUpdateSuccess}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notify"
              element={
                <ProtectedRoute>
                  <Notify setTab={setTab} accountSummary={accountSummary} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sync"
              element={
                <ProtectedRoute>
                  <Sync setTab={setTab} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wash-inventory"
              element={
                <ProtectedRoute>
                  <WashInventory
                    setTab={setTab}
                    accountSummary={accountSummary}
                    washTypes={washTypes}
                    washInventoryList={syncedWashInventoryList}
                    washedFleetList={washedFleetList}
                    accountWashTypes={accountWashTypes}
                    vehicleNumberList={vehicleNumberList}
                    instructionAcknowledgements={instructionAcknowledgements}
                    onSave={createWashInventory}
                    onBulkSave={createBulkWashInventory}
                    onAcknowledgement={createAcknowledgement}
                    setToastMessage={setToastMessage}
                  />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Row>
        <Row>
          <Tabbar tabName={tabName} isPasswordReset={isPasswordReset} />
        </Row>
        <ToastContainer />
      </Container>
      {/* </div> */}
    </UserContext.Provider>
  );
}

export default App;
